import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import LeafletMapConnected from '../containers/LeafletMapConnected';
import SidebarConnected from '../containers/SidebarConnected';
import SidebarMenu from './SidebarMenu';
import LegendConnected from '../containers/LegendConnected';
import DistanceReadout from './DistanceReadout';

class App extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { fetchWpJsonApiData, trailheadsToggled } = this.props;

    // fetch trailheads or trips data depending which is set in state.sidebar
    if (trailheadsToggled) fetchWpJsonApiData('trailheads');
    if (!trailheadsToggled) fetchWpJsonApiData('trips');
  }

  componentWillReceiveProps(nextProps) {
    const { fetchWpJsonApiData, trailheadsToggled, trips, trailheads } = nextProps;

    // if user toggled trips / trailheads and data hasn't been loaded for one, then fetch it
    if (trailheadsToggled !== this.props.trailheadsToggled) {
      if (!this.props.trips) fetchWpJsonApiData('trips');
      if (!this.props.trailheads) fetchWpJsonApiData('trailheads');
    }
  }

  componentDidUpdate(prevProps) {
    const { selected, trailheadsToggled } = this.props;

    // update the query params if a trip or trailhead was selected by the user
    if (selected && selected !== prevProps.selected) {
      const stringified = queryString.stringify({
        type: trailheadsToggled ? 'trailheads' : 'trips',
        id: selected,
      });
      this.updateBrowserHistory(stringified);
    }

    // remove any query params when a trip or trailhead is deselected
    if (!selected && prevProps.selected) {
      this.updateBrowserHistory()
    }
  }

  updateBrowserHistory(query) {
    const { history, location } = window;
    const { protocol, host, pathname } = location;
    const baseUrl = `${protocol}//${host}${pathname}`;
    const newUrl = query ? `${baseUrl}?${query}` : baseUrl;
    // HTML5 History API used to update query params without a page reload, modern browser support only (IE10+)
    history.replaceState({ path: newUrl }, '', newUrl);
  }

  showLegend() {
    const { width, sidebar } = this.props;
    const legend = <LegendConnected />;

    if (width < 420 && sidebar) {
      return null;
    }

    if (width < 420 && !sidebar) {
      return legend;
    }

    return legend;
  }

  render() {
    const { measuredDistance, sidebar, sidebarOpen, width } = this.props;

    return (
      <div className="App">
        <SidebarConnected />
        <SidebarMenu sidebar={sidebar} handleClick={() => sidebarOpen()} />
        { this.showLegend() }
        <LeafletMapConnected />
        <DistanceReadout distance={measuredDistance} />
      </div>
    );
  }
}

App.propTypes = {
  fetchWpJsonApiData: PropTypes.func.isRequired,
  measuredDistance: PropTypes.string,
  sidebar: PropTypes.bool.isRequired,
  sidebarOpen: PropTypes.func.isRequired,
  trailheadsToggled: PropTypes.bool.isRequired,
  width: PropTypes.number.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./map/components/App.js